import React, { useState } from 'react';
import { Handshake } from 'lucide-react';
export function Contracts() {
  const [contracts, setContracts] = useState([{
    description: 'Real Estate Investment with Player 3'
  }, {
    description: 'Small Business Partnership with Player 5'
  }, {
    description: 'Stock Portfolio Co-Investment with Player 2'
  }, {
    description: ''
  }, {
    description: ''
  }]);
  const handleDescriptionChange = (index: number, newDescription: string) => {
    const updatedContracts = [...contracts];
    updatedContracts[index] = {
      ...updatedContracts[index],
      description: newDescription
    };
    setContracts(updatedContracts);
  };
  const addContract = () => {
    setContracts([...contracts, {
      description: ''
    }]);
  };
  return <div className="bg-white p-6 rounded-lg shadow-sm border border-gray-100 w-full" data-id="element-50">
      <div className="flex items-center mb-4" data-id="element-51">
        <Handshake size={20} className="text-green-500 mr-2" data-id="element-52" />
        <h2 className="text-xl font-semibold" data-id="element-53">Contracts</h2>
      </div>
      <div className="space-y-3" data-id="element-54">
        {contracts.map((contract, index) => <div key={index} className="flex items-center p-3 bg-gray-50 rounded-md" data-id="element-55">
            <input type="text" value={contract.description} onChange={e => handleDescriptionChange(index, e.target.value)} placeholder="Description" className="text-gray-700 bg-transparent border-b border-transparent focus:border-green-500 focus:outline-none w-full" data-id="element-56" />
          </div>)}
      </div>
      <button onClick={addContract} className="mt-4 text-sm text-green-600 hover:text-green-800 font-medium" data-id="element-57">
        + Add Contract
      </button>
    </div>;
}